import JSON5 from "json5";

import { getConfig } from "lib/get-config";
import { TableOfContents } from "lib/types";

export async function getToc(): Promise<TableOfContents> {
  const { contentUrl } = getConfig();
  const response = await fetch(`${contentUrl}json/toc.js`);
  if (response.status === 403) {
    throw new Error("Forbidden");
  }
  if (!response.ok) {
    throw new Error(`Failed to fetch toc: ${response.status}`);
  }
  const data = await response.text();
  return JSON5.parse(data);
}
